// src/api/eventEmail.js

const API_URL = "https://sendeventemail-wyjrul2qza-as.a.run.app";

export async function sendEventEmail(payload) {
  try {
    const res = await fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      throw new Error("Failed to send event email");
    }

    return await res.text(); // "Email sent!"
  } catch (err) {
    console.error("sendEventEmail error:", err);
    throw err;
  }
}
